<!--
 * @Author: 汪俊洪
 * @Date: 2023-07-10 19:14:04
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2023-07-11 11:22:56
 * @Description: 添加备注
-->
<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0">
    <el-form-item label="" prop="remark">
      <el-input
        type="textarea"
        maxlength="500"
        :autosize="{ minRows: 3, maxRows: 10 }"
        resize="none"
        show-word-limit
        placeholder="请输入备注内容。若需添加图片，请在附件中上传。"
        v-model="ruleForm.remark"
      ></el-input>
    </el-form-item>
    <el-form-item class="right">
      <el-button size="small" :loading="loading" @click="cancel"
        >取消</el-button
      >
      <el-button
        size="small"
        :loading="loading"
        type="primary"
        @click="submitForm"
        >确定</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  props: {
    userAfterSalesCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      ruleForm: {
        remark: ''
      },
      rules: {
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
      },
      loading: false
    }
  },
  methods: {
    submitForm () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.doSubmit()
        }
      })
    },
    doSubmit () {
      if (this.loading) {
        return
      }
      this.loading = true
      const obj = {
        ...this.ruleForm,
        userAfterSalesCode: this.userAfterSalesCode
      }
      this.$http
        .post('/front/consumer/userAfterSales/addOmsUserAfterSalesRemark', obj)
        .then(({ data: res }) => {
          this.loading = false
          if (res.code !== 0) {
            return
          }
          this.$emit('success')
        })
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.right {
  text-align: right;
  margin-bottom: -14px;
}
</style>
